import { AxiosInstance } from 'axios';
import { ClassGroupWorkplaceRepository } from '@/model/repository/shift/ClassGroupWorkplaceRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ClassGroupWorkplaceRepository => ({
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
